import React, { useState } from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import Popover from 'ui/Popover';
import ActionList from 'ui/ActionList';
import { BetaLabel } from 'components/BetaProgram';
import ContentPaperEditIcon from './icons/ContentPaperEditIcon';
import ZipFileIcon from './icons/ZipFileIcon';

const NewSectionDropdown = ({
  addSection,
  containerStyle,
  sticky,
  stickyBottom,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const actionListStyle = containerStyle
    ? { width: `calc(${containerStyle.width} - 30px)` }
    : { width: '207.8px' };

  return (
    <Popover
      activator={
        <button
          type="button"
          className="NewButton NewButton--dark NewButton--center NewSectionPopoverTrigger"
          data-testid="NewSectionPopoverTrigger"
          onClick={() => setIsOpen(!isOpen)}
        >
          <Icon name="caret_down" aria-label="Caret Down Icon" />
        </button>
      }
      className={classNames('NewSectionPopover', {
        sticky,
        'sticky--bottom': stickyBottom,
      })}
      align="right"
      visible={isOpen}
      onClose={() => setIsOpen(false)}
      onSelect={() => setIsOpen(false)}
    >
      <div className="NewSectionPopoverList" style={actionListStyle}>
        <ActionList
          items={[
            {
              content: (
                <div className="d-f ai-c mt-4">
                  <ContentPaperEditIcon />
                  {t('lessons.editor.sections.elements_section')}
                </div>
              ),
              onClick: () => addSection('Paragraph'),
            },
            {
              content: (
                <div className="d-f ai-c mb-4">
                  <ZipFileIcon />
                  {t('lessons.editor.sections.elearning_section')}
                  <BetaLabel whiteOnBlack />
                </div>
              ),
              onClick: () => addSection('Scorm'),
            },
          ]}
        />
      </div>
    </Popover>
  );
};

export default NewSectionDropdown;
